import React from 'react';
import { usePopoverStateManager, PopoverStateContext } from '@/hooks/usePopoverStateManager';

interface PopoverStateProviderProps {
  children: React.ReactNode;
}

export const PopoverStateProvider: React.FC<PopoverStateProviderProps> = ({ children }) => {
  const popoverManager = usePopoverStateManager();

  return (
    <PopoverStateContext.Provider value={popoverManager}>
      {children}
    </PopoverStateContext.Provider>
  );
};